import { render } from "./PublicationLoader.vue?vue&type=template&id=6719682e"
import script from "./PublicationLoader.vue?vue&type=script&lang=js"
export * from "./PublicationLoader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__